import { EuiFlexGroup, EuiFlexItem, EuiPanel, EuiSpacer, EuiText } from "@elastic/eui";
import { shallowEqual, useSelector } from "react-redux";
import VerticalRule from "components/VerticalRule";
import Button from "components/Buttons/Button";
import Modal from "components/Modal/Modal";
import ActionButtons from "components/Buttons/ActionButtons";
import { authSelector } from "reduxStore/auth/auth.selectors";
import ProfileAssignmentIcons from "./ProfileAssignmentIcons";
import { getProfileExportConfig } from "../profileUtils";

const ProfileCompleteModal = ({
  setIsFormModalOpen,
  setIsProfileCreatedModalOpen,
  profile,
  refetch,
}: any) => {
  const { currentUser } = useSelector(authSelector, shallowEqual);

  const handleClose = () => {
    refetch();
    setIsProfileCreatedModalOpen(false);
    setIsFormModalOpen(false);
  };

  const Footer = () => {
    return (
      <>
        <EuiFlexItem grow={false}>
          <Button type="primary" text="Close" onClick={handleClose} />
        </EuiFlexItem>
      </>
    );
  };

  if (!profile) return null;

  return (
    <Modal title="Profile Created" onClose={handleClose} footer={<Footer />}>
      <EuiText>
        Congratulations! The profile has been created successfully - you can view or edit its
        details anytime.
        <EuiSpacer size="s" />
      </EuiText>

      <EuiPanel hasBorder={true} hasShadow={false}>
        <EuiFlexGroup justifyContent="spaceBetween" alignItems="center">
          <EuiFlexItem grow={false}>
            <EuiText>
              <p>{profile?.name}</p>
            </EuiText>
          </EuiFlexItem>
          <EuiFlexItem grow={false}>
            <EuiFlexGroup alignItems="center" gutterSize="none">
              <ProfileAssignmentIcons profile={profile} />
              <VerticalRule marginRight="2px" />
              <ActionButtons
                length={1}
                currentUser={currentUser}
                buttons={[
                  {
                    type: "export",
                    disabled: false,
                    exportConfig: getProfileExportConfig(profile),
                    onClick: () => {},
                  },
                ]}
              />
            </EuiFlexGroup>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiPanel>
    </Modal>
  );
};

export default ProfileCompleteModal;
